var validateNumberInput = function (event) {
    var eventKeys = ["e", "E", ".", "-", "+"];
    if (eventKeys.includes(event.key) || !event.key.match(/^[0-9]+$/)) {
        event.preventDefault();
    }
};
export default validateNumberInput;
